<template>
  <div v-if="hasPermission(permissions.depositTypesList)">
    <content-header>{{ $t('depositTypes') }}</content-header>
    <v-content>
      <BootstrapTable
          :rows="rows"
          :columns="columns"
          :config="config"
          :total-rows="totalRecords"
          :actions="actions"
          @on-change-query="onChangeQuery"
          @on-create="$router.push({name: 'depositTypes.create'})"
          @on-multiple-delete="onMultipleDelete"
      >
        <template slot="empty-results">{{ $t('noResultsFound') }}</template>
        <template slot="pagination-info" slot-scope="props">
          <template v-if="props.currentPageRowsLength !== 0">{{totalRecords}} {{ $t('totalRecords') }}</template>
          <template v-else>{{ $t('noResultsFound') }}</template>
        </template>
        <template slot="controls" slot-scope="props" v-if="hasPermission(permissions.depositTypesEdit) || hasPermission(permissions.depositTypesDelete)">
          <control-buttons
              :props="props"
              :edit-link="hasPermission(permissions.depositTypesEdit) && 'depositTypes.edit'"
              :delete-link="hasPermission(permissions.depositTypesDelete) && 'depositTypes/DELETE'"
              v-on:successAction="loadData(true)"
          />
        </template>
      </BootstrapTable>
      <is-loading v-if="isLoading" />
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import {DepositType} from "@/models/DepositType";
import IsLoading from "@/components/IsLoading";
import ControlButtons from "@/components/ControlButtons";
import {actions, permissions, serverParams, swalMixin, tableActions, tableConfigure} from "@/plugins/constants";
import BootstrapTable from "@/components/Table/BootstrapTable";

export default {
  name: "DepositTypeList",
  components: {ControlButtons, IsLoading, 'v-content': Content, ContentHeader, BootstrapTable},
  data() {
    return {
      isLoading: false,
      model: new DepositType(),
      columns: [],
      rows: [],
      actions: tableActions(this.hasPermission(permissions.depositTypesCreate)),
      totalRecords: 0,
      config: tableConfigure(this.$t('depositTypeList'), true, false),
      serverParams: serverParams,
      selectedRows: [],
      permissions: permissions
    };
  },
  beforeMount() {
    this.columns  = this.model.getColumns();
  },
  methods: {
    loadData(reset = false) {
      if (reset) {
        serverParams._start   = 0
        serverParams._end     = 10
        serverParams._sort    = ''
        serverParams._order   = ''
        serverParams._search  = ''
      }
      this.isLoading = true;
      this.$store.dispatch('depositTypes/GET_ALL', this.serverParams)
          .then((response) => {
            this.rows         = response.data
            this.totalRecords = parseInt(response.headers['x-total-count'])
            this.isLoading    = false
          })
          .catch(() => this.isLoading = false);
    },
    onChangeQuery(queryParams) {
      serverParams._start   = (queryParams.page - 1) * queryParams.per_page
      serverParams._end     = queryParams.page * queryParams.per_page
      serverParams._sort    = queryParams.sort[0] ? queryParams.sort[0].name : ''
      serverParams._order   = queryParams.sort[0] ? queryParams.sort[0].order : ''
      serverParams._search  = queryParams.global_search ?? ''
      this.loadData()
    },
    async onMultipleDelete() {
      if (this.selectedRows.length === 0) {
        swalMixin('error', 'noRows')
        return false;
      }
      if (await actions('depositTypes/DELETE', this.selectedRows, 'delete')) {
        this.loadData();
      }
    },
  }
}
</script>
